import { collectionEngineV1 } from '../apis';
const searchAPI = collectionEngineV1('/search');
export const all = (q, c) => searchAPI('GET', `/${encodeURIComponent((q || '').trim())}${c ? `?config=${encodeURIComponent(JSON.stringify(c))}` : ''}`);
//# sourceMappingURL=search.js.map